module.exports = __webpack_public_path__ + "Roboto-Regular.766c8926f6d9061fef24.svg";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/roboto-fontface/fonts/roboto/Roboto-Regular.svg
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-Regular.svg
// module chunks = styles